__turbopack_context__.v({
  "actionButton": "not-found-module-scss-module__HfxUKG__actionButton",
  "description": "not-found-module-scss-module__HfxUKG__description",
  "details": "not-found-module-scss-module__HfxUKG__details",
  "errorCode": "not-found-module-scss-module__HfxUKG__errorCode",
  "image": "not-found-module-scss-module__HfxUKG__image",
  "imageWrapper": "not-found-module-scss-module__HfxUKG__imageWrapper",
  "innerWrapper": "not-found-module-scss-module__HfxUKG__innerWrapper",
  "linksTitle": "not-found-module-scss-module__HfxUKG__linksTitle",
  "title": "not-found-module-scss-module__HfxUKG__title",
  "wrapper": "not-found-module-scss-module__HfxUKG__wrapper",
});
